<template>
  <form style="margin-bottom: 50px;">
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="card" style="height:100%; width:100%; margin: 0;">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-content">
          <p class="text-danger" v-if="errors.has('error')">
            {{ getError('error') }}
          </p>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>ID</label>
                <input type="number"
                  disabled
                  placeholder="ID"
                  v-model="model.id"
                  class="form-control">
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Name</label>
                <input type="text"
                  placeholder="Name"
                  v-validate="modelValidate.name"
                  v-model="model.name"
                  class="form-control">
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>{{$t('settingTable.location')}}</label>
                <select
                  name="location"
                  class="form-control"
                  v-validate="modelValidate.location_id"
                  v-model="model.location_id"
                  @change="getTables()"
                  :disabled="id ? true : false"
                >
                  <option value="null" disabled>{{$t('general.none')}}</option>
                  <option
                    v-for="(loc) in locations"
                    :value="loc.id"
                    :label="loc.name"
                    :key="loc.id">
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label>Scale Factor</label>
                <input
                  type="range"
                  v-model="scaleFactor"
                  min="0.5"
                  max="1.5"
                  step="0.1"
                  @change="updateTableManagerMapsDimensions()"
                  class="form-control-range">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label>{{$t('settingTable.allow_some_top_categories_map')}}</label>
                <!-- <p-switch v-model="model.allow_some_top_categories" type="success" ></p-switch> -->
                <div class="form-group">
                  <el-select
                    key="methods"
                    name="methods"
                    v-model="model.allowed_top_categories"
                    multiple
                    filterable
                    default-first-option
                    style="width: 100%; color: #fff;"
                    :placeholder="$t('general.add')">
                    <el-option
                      :value="null"
                      :label="$t('general.all')"
                      :key="0" disabled>
                    </el-option>
                    <template v-for="item in topCategories">
                          <el-option
                            :value="item.id"
                            :label="item.name">
                          </el-option>
                    </template>
                  </el-select>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-md-12">
        <p style="text-align: center;">Trage din dreapta mesele si aseazale pe harta</p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-md-9">
        <div class="map" ref="svgMap">
          <p>Harta:</p>
          <div :class="(loadingTable ? 'show-loader' : 'hide-loader')">
            <div class="center">
              <span>Selecteaza locatia...</span>
            </div>
          </div>
          <div class="card" style="height:100%; width:100%; margin: 0;" v-if="tables">
            <svg
                width="100%"
                height="100%"
                class="harta-bg"
                @drop="onDrop"
                @dragover.prevent
                style="border: 1px solid #ddd;"
                @mousemove="resizeTable"
                @mouseup="endResize"
              >
              <template v-for="(table, index) in model.table_manager_maps">
                <template v-if="!table.deleted">
                  <g :key="index">
                      <foreignObject
                        v-if="table.table_manager_id !== -1"
                        :x="table.draw_data.x"
                        :y="table.draw_data.y"
                        :width="table.draw_data.width"
                        :height="table.draw_data.height"
                        :transform="'rotate(' + table.draw_data.rotation + ' ' + (table.draw_data.x + table.draw_data.width / 2) + ' ' + (table.draw_data.y + table.draw_data.height / 2) + ')'"
                        @mousedown="selectTable(index, $event)"
                        style="cursor: move;"
                      >
                        <component :is="getTableComponent(table.table_manager_id)" />
                      </foreignObject>

                      <rect
                        v-if="table.table_manager_id === -1"
                        :x="table.draw_data.x"
                        :y="table.draw_data.y"
                        :width="table.draw_data.width"
                        :height="table.draw_data.height"
                        :transform="'rotate(' + table.draw_data.rotation + ' ' + (table.draw_data.x + table.draw_data.width / 2) + ' ' + (table.draw_data.y + table.draw_data.height / 2) + ')'"
                        fill="#000"
                        @mousedown="selectTable(index, $event)"
                        style="cursor: move;"
                      />

                      <text
                        :x="table.draw_data.x + table.draw_data.width / 2"
                        :y="table.draw_data.y + table.draw_data.height / 2"
                        text-anchor="middle"
                        alignment-baseline="middle"
                        fill="#fff"
                        font-size="14"
                        pointer-events="none"
                        style="user-select: none;"
                      >
                        <template v-if="table.table_manager_id !== -1">
                          {{ tableMapTableNumber(table.table_manager_id) }}
                        </template>
                        <template v-else>Obiect</template>
                      </text>

                      <text
                        :x="table.draw_data.x - 5"
                        :y="table.draw_data.y + 15"
                        fill="#FF0000"
                        font-size="16"
                        font-weight="bold"
                        style="cursor: pointer; user-select: none;"
                        @click.stop="deleteTable(index, table.table_manager_id)"
                      >
                        X
                      </text>

                      <text
                        v-if="table.table_manager_id !== -1"
                        :x="table.draw_data.x + table.draw_data.width - 10"
                        :y="table.draw_data.y + 15"
                        fill="#fff"
                        font-size="16"
                        style="cursor: pointer; user-select: none;"
                        @click.stop="editTable(table)"
                      >
                        ✏️
                      </text>

                      <circle
                        v-if="table.table_manager_id === -1"
                        :cx="table.draw_data.x + table.draw_data.width"
                        :cy="table.draw_data.y + table.draw_data.height"
                        r="5"
                        fill="#674BD2"
                        @mousedown.stop="startResize(index)"
                        style="cursor: se-resize;"
                      />
                  </g>
                  <text
                    :x="table.draw_data.x + table.draw_data.width - 30"
                    :y="table.draw_data.y + 15"
                    fill="#fff"
                    font-size="16"
                    style="cursor: pointer; user-select: none;"
                    @click.stop="rotateTable(index, 10)"
                  >
                    🔄
                  </text>
                </template>
              </template>
            </svg>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <p>Mese:</p>
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loadingTable ? 'show-loader' : 'hide-loader')">
            <div class="center">
              <span>Selecteaza locatia...</span>
            </div>
          </div>
          <div class="allTables">
            <div class="table newTable" draggable="true" @dragstart="onDragStartNew($event)">+ Masa Noua</div>
            <div class="table newTable" draggable="true" @dragstart="onDragObject($event)">+ Obiect</div>
            <p>Mese existante:</p>
            <div class="scrolDiv">
              <template v-for="table in tables">
                <div class="table" draggable="true" @dragstart="onDragStart($event, table)" v-if="!table.table_maps_id">
                  <span class="edit1" @click="editTable(null, table)"><i class="fa fa-pencil"></i></span>
                  <p class="number">{{table.number}}</p>
                  <div>
                    <p class="type">{{$t('settingTable.type')}}: {{table.type}}</p>
                    <p class="zone">{{$t('settingTable.zone')}}: {{table.zone}}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="slide-right">
      <global-modal v-if="showTableModal" @close="closeTableModal">
        <table-management-form
          @on-submit="onUserSubmit"
          :callback="tableManagementUpdate"
          :tableId="selectedTable"
          :fromExternal="true"
          :autoselectLocation="model.location_id"
          :posUsers="formattedUsers"
        >
          <a slot="back-button" class="btn btn-orange btn-icon back table-modal-back" :title="$t('general.back')" @click.prevent="closeTableModal">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </table-management-form>
      </global-modal>
    </transition>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import GlobalModal from 'src/components/UIComponents/GlobalModal.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  import TableManagementForm from './../../Settings/TableManagement/TableManagementForm.vue'

  // SVG
  import t1 from './../svg/t1'
  import t2 from './../svg/t2'
  import t3 from './../svg/t3'
  import t4 from './../svg/t4'
  import t5 from './../svg/t5'
  import t6 from './../svg/t6'
  import t7 from './../svg/t7'
  import t8 from './../svg/t8'
  import t9 from './../svg/t9'
  import t10 from './../svg/t10'
  import t11 from './../svg/t11'
  import t12 from './../svg/t12'
  import r1 from './../svg/r1'
  import r2 from './../svg/r2'
  import r3 from './../svg/r3'
  import r4 from './../svg/r4'
  import r5 from './../svg/r5'
  import r6 from './../svg/r6'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      t1,
      t2,
      t3,
      t4,
      t5,
      t6,
      t7,
      t8,
      t9,
      t10,
      t11,
      t12,
      r1,
      r2,
      r3,
      r4,
      r5,
      r6,
      TableManagementForm,
      GlobalModal,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.company_id = this.$session.get('selectedCompany')
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    data () {
      return {
        id: this.route.params.id || null,
        company_id: null,
        locations: [],
        tables: [],
        model: {
          'id': 0,
          'name': null,
          'location_id': null,
          'table_manager_maps': []
        },
        posUsers: [],
        scaleFactor: 1,
        offset: { x: 0, y: 0 },
        draggingTable: null,
        selectedTableIndex: null,
        selectedTable: null,
        showTableModal: false,
        resizing: false,
        modelValidate: {
          name: {required: true},
          location_id: {required: true}
        },
        topCategories: null,
        loadingTable: true,
        loading: true
      }
    },
    computed: {
      formattedUsers () {
        return this.posUsers.map(user => ({
          ...user,
          fullname: `${user.firstname} ${user.lastname}` // Add a fullname field
        }))
      }
    },
    mounted () {
      window.addEventListener('mousemove', this.updateTablePosition)
      window.addEventListener('mouseup', () => (this.selectedTableIndex = null))
    },
    beforeDestroy () {
      window.removeEventListener('mousemove', this.updateTablePosition)
    },
    methods: {
      tableMapTableNumber (tableManagerId) {
        if (this.tables && this.tables.length) {
          let table = this.tables.find(tableFromTables => tableFromTables.id === tableManagerId)
          if (table) {
            return table.number
          }
        }
        return ''
      },
      getTableComponent (tableManagerId) {
        if (this.tables && this.tables.length) {
          let table = this.tables.find(tableFromTables => tableFromTables.id === tableManagerId)
          if (table) {
            if (table.table_shape === 'round') {
              if (!table.max_pers) {
                return 'r4'
              }
              if (table.max_pers >= 6) {
                return 'r6'
              } else {
                return 'r' + table.max_pers
              }
            } else {
              if (!table.max_pers) {
                return 't4'
              }
              if (table.max_pers >= 12) {
                return 't12'
              } else {
                return 't' + table.max_pers
              }
            }
          }
        }
        return 't4'
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        this.getPosUsers()
        var id = this.id || this.route.params.id

        if (id) {
          let data = {
            token: this.$session.get('token'),
            company_id: this.company_id
          }
          this.apiRequest('/pos/map/' + id, 'GET', data, (response) => {
            if (response.status) {
              this.model = response.data.table_map
            }
            this.loading = false
            this.getTables()
          })
        } else {
          this.getTables()
        }

        this.locations = []
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }

        this.apiRequest('/get-locations', 'GET', requestData, (response) => {
          if (response.status) {
            this.locations = response.data
          }
          if (!id) {
            this.loading = false
          }
        })

        var data2 = {
          token: this.$session.get('token'),
          company_id: this.company_id
        }
        this.apiRequest('/topcategory', 'GET', data2, (topCatResp) => {
          if (topCatResp.status === true) {
            this.topCategories = topCatResp.data
          }
        })
      },
      getPosUsers () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status) {
            this.posUsers = response.data.pos_user
          }
        })
      },
      getTables () {
        this.loadingTable = true
        this.tables = []
        if (!this.id) {
          this.model.table_manager_maps = []
        }
        if (this.model.location_id) {
          let requestData = {
            token: this.$session.get('token'),
            company_id: this.company_id,
            location_id: this.model.location_id
          }

          this.apiRequest('/pos/map/get-tables', 'GET', requestData, (response) => {
            if (response.status) {
              // this.tables = response.data
              Vue.set(this, 'tables', response.data)
            }
            this.loadingTable = false

            if (this.id && this.model.table_manager_maps.length > 0) {
              this.inferScaleFactorFromData()
            }
          })
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.loadingTable = true
        this.loading = true

        let data = {
          'token': this.$session.get('token'),
          'company_id': this.company_id,
          ...this.model
        }

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/pos/map/' + id
          request = 'PUT'
        } else {
          url = '/pos/map/add'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/pos/map/' + response.data.table_maps.id)
            } else {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/pos/map/' + response.data.table_map.id)
              // this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.handleErrors(response.errors)
          }
          this.loading = false
          this.loadingTable = false
        })
      },
      deleteOrderScreen () {
        this.loadingReset = true
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.company_id,
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/pos/map/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
          this.loadingReset = false
        })
      },
      editTable (tableMap, table) {
        if (tableMap) {
          this.selectedTable = tableMap.table_manager_id
        } else {
          this.selectedTable = table.id
        }
        this.showTableModal = true
      },
      closeTableModal () {
        this.showTableModal = false
      },
      tableManagementUpdate (respTable, isNew, deletedTableId) {
        this.closeTableModal()
        if (respTable) {
          if (isNew) {
            this.draggingTable = {
              ...this.draggingTable,
              ...respTable
            }
            respTable.table_maps_id = this.model.id || true
            this.tables.push(respTable)
            this.onDrop()
          } else {
            let tableIndex = this.tables.findIndex(tableFromTables => tableFromTables.id === respTable.id)

            const isDeletedOnMap = this.model.table_manager_maps.some(
              tm => tm.table_manager_id === respTable.id && tm.deleted
            )
            if (isDeletedOnMap) {
              respTable.table_maps_id = 0
            } else {
              // Păstrează table_maps_id doar dacă nu e ștearsă
              const existingTable = this.tables[tableIndex]
              if (existingTable && existingTable.table_maps_id) {
                respTable.table_maps_id = existingTable.table_maps_id
              }
            }

            // this.tables[tableIndex] = respTable
            Vue.set(this.tables, tableIndex, respTable)
            // console.log('Reload Table')
            this.updateTableManagerMapsDimensions()
          }
        } else {
          // console.log('Delete Table')
          let tableIndex = this.tables.findIndex(tableFromTables => tableFromTables.id === deletedTableId)
          if (this.tables[tableIndex].table_maps_id) {
            let tableMapIndex = this.model.table_manager_maps.findIndex(tableFromTablesMap => tableFromTablesMap.table_manager_id === deletedTableId)
            if (tableMapIndex !== -1) {
              this.model.table_manager_maps[tableMapIndex].deleted = true
              this.validate()
            }
          }
          if (tableIndex !== -1) {
            this.tables.splice(tableIndex, 1)
          }
        }
      },
      onUserSubmit () {
        console.log('onUserSubmit')
      },


      onDragObject (event) {
        this.selectedTable = null
        let table = {
          id: -1,
          table_maps_id: this.model.id || true,
          isObject: true
        }
        this.draggingTable = { ...table, width: 60, height: 60 }
      },
      onDragStartNew (event) {
        this.selectedTable = null
        let table = {
          id: 0,
          table_maps_id: this.model.id || true
        }
        this.draggingTable = { ...table, width: 60, height: 60 }
      },
      onDragStart (event, table) {
        this.draggingTable = { ...table, width: 60, height: 60 }
      },
      onDrop (event) {
        if (event) {
          this.draggingTable.onDropEvent = event
        }

        // Nu avem ce procesa
        if (!this.draggingTable) {
          return
        }

        // SA NU FIE OBIECT
        if (this.draggingTable.id !== -1) {
          // --- VERIFICARE DUPLICAT (inclusiv mesele marcate deleted) ---
          const existingIndex = this.model.table_manager_maps.findIndex(
            t => t.table_manager_id === this.draggingTable.id
          )

          if (existingIndex !== -1) {
            const existing = this.model.table_manager_maps[existingIndex]

            // Reactivează masa ștearsă
            existing.deleted = false

            // Actualizează table_maps_id și în array-ul tables
            const tableToUpdate = this.tables.find(t => t.id === this.draggingTable.id)
            if (tableToUpdate) {
              tableToUpdate.table_maps_id = this.model.id || true
            }

            // Dacă avem coordonate noi din drag, actualizează poziția
            if (this.draggingTable.onDropEvent) {
              const svgRect = this.$refs.svgMap.getBoundingClientRect()
              const x = this.draggingTable.onDropEvent.clientX - svgRect.left
              const y = this.draggingTable.onDropEvent.clientY - svgRect.top

              existing.draw_data.x = Math.max(0, Math.min(x, svgRect.width - existing.draw_data.width))
              existing.draw_data.y = Math.max(0, Math.min(y, svgRect.height - existing.draw_data.height))
            }

            this.draggingTable = null
            this.updateTableManagerMapsDimensions()
            return
          }
          // --- SFÂRȘIT VERIFICARE DUPLICAT ---
        }

        // Obiect (nu masă)
        if (this.draggingTable.isObject) {
          const svgRect = this.$refs.svgMap.getBoundingClientRect()
          const x = this.draggingTable.onDropEvent.clientX - svgRect.left
          const y = this.draggingTable.onDropEvent.clientY - svgRect.top

          const drawData = {
            x: Math.max(0, Math.min(x, svgRect.width - this.draggingTable.width)),
            y: Math.max(0, Math.min(y, svgRect.height - this.draggingTable.height)),
            width: this.draggingTable.width,
            height: this.draggingTable.height,
            rotation: 0
          }

          this.model.table_manager_maps.push({
            id: 0,
            company_id: this.company_id,
            table_manager_id: this.draggingTable.id,
            table_maps_id: this.model.id,
            draw_data: drawData
          })

          this.draggingTable = null
          this.updateTableManagerMapsDimensions()
          return
        }

        // Masă nouă (id === 0) — deschide modalul
        if (this.draggingTable.id === 0) {
          this.showTableModal = true
          return
        }

        // Drag normal masă existentă (id real > 0)
        this.draggingTable.table_maps_id = this.model.id || true
        const tableToUpdate = this.tables.find(t => t.id === this.draggingTable.id)
        if (tableToUpdate) {
          tableToUpdate.table_maps_id = this.model.id || true
        }

        const svgRect = this.$refs.svgMap.getBoundingClientRect()
        const x = this.draggingTable.onDropEvent.clientX - svgRect.left
        const y = this.draggingTable.onDropEvent.clientY - svgRect.top

        const drawData = {
          x: Math.max(0, Math.min(x, svgRect.width - this.draggingTable.width)),
          y: Math.max(0, Math.min(y, svgRect.height - this.draggingTable.height)),
          width: this.draggingTable.width,
          height: this.draggingTable.height,
          rotation: 0
        }

        this.model.table_manager_maps.push({
          id: 0,
          company_id: this.company_id,
          table_manager_id: this.draggingTable.id,
          table_maps_id: this.model.id,
          draw_data: drawData
        })

        this.draggingTable = null
        this.updateTableManagerMapsDimensions()
      },
      updateTableManagerMapsDimensions () {
        this.model.table_manager_maps.forEach(tableMap => {
          if (tableMap.table_manager_id !== -1) {
            let table = this.tables.find(t => t.id === tableMap.table_manager_id)
            if (table) {
              if (table.table_shape === 'round') {
                if (table.max_pers <= 4) {
                  tableMap.draw_data.width = 50 * this.scaleFactor
                  tableMap.draw_data.height = 50 * this.scaleFactor
                } else {
                  tableMap.draw_data.width = 70 * this.scaleFactor
                  tableMap.draw_data.height = 70 * this.scaleFactor
                }
              } else {
                if (table.max_pers <= 1) {
                  tableMap.draw_data.width = 40 * this.scaleFactor
                  tableMap.draw_data.height = 40 * this.scaleFactor
                } else if (table.max_pers <= 2) {
                  tableMap.draw_data.width = 50 * this.scaleFactor
                  tableMap.draw_data.height = 50 * this.scaleFactor
                } else if (table.max_pers <= 3) {
                  tableMap.draw_data.width = 60 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 4) {
                  tableMap.draw_data.width = 60 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 5) {
                  tableMap.draw_data.width = 90 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 6) {
                  tableMap.draw_data.width = 90 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 7) {
                  tableMap.draw_data.width = 100 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 8) {
                  tableMap.draw_data.width = 100 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 9) {
                  tableMap.draw_data.width = 120 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 10) {
                  tableMap.draw_data.width = 140 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers <= 11) {
                  tableMap.draw_data.width = 180 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                } else if (table.max_pers >= 12) {
                  tableMap.draw_data.width = 180 * this.scaleFactor
                  tableMap.draw_data.height = 60 * this.scaleFactor
                }
              }
            } else {
              tableMap.draw_data.width = 60 * this.scaleFactor
              tableMap.draw_data.height = 60 * this.scaleFactor
            }
          } else {
            // isObject
          }
        })
      },
      inferScaleFactorFromData () {
        // Caută prima masă validă (nu obiect, nu ștearsă, cu draw_data)
        const firstTableMap = this.model.table_manager_maps.find(t =>
          t.table_manager_id !== -1 &&
          !t.deleted &&
          t.draw_data &&
          t.draw_data.width > 0
        )

        if (!firstTableMap) {
          this.scaleFactor = 1  // default dacă nu găsește nimic
          return
        }

        const width = firstTableMap.draw_data.width
        const table = this.tables.find(t => t.id === firstTableMap.table_manager_id)

        if (!table) {
          this.scaleFactor = 1
          return
        }
        // Inversează logica din updateTableManagerMapsDimensions()
        // pentru a afla scaleFactor din width
        if (table.table_shape === 'round') {
          if (table.max_pers <= 4) {
            this.scaleFactor = width / 50
          } else {
            this.scaleFactor = width / 70
          }
        } else {
          // rectangular
          if (table.max_pers <= 1) {
            this.scaleFactor = width / 40
          } else if (table.max_pers <= 2) {
            this.scaleFactor = width / 50
          } else if (table.max_pers <= 4) {
            this.scaleFactor = width / 60
          } else if (table.max_pers <= 6) {
            this.scaleFactor = width / 90
          } else if (table.max_pers <= 8) {
            this.scaleFactor = width / 100
          } else if (table.max_pers <= 10) {
            this.scaleFactor = width / 140
          } else { // >= 11, 12
            this.scaleFactor = width / 180
          }
        }
        // Limitează la range-ul valid al slider-ului
        this.scaleFactor = Math.max(0.5, Math.min(1.5, this.scaleFactor))
      },
      selectTable (index, event) {
        this.selectedTableIndex = index
        const table = this.model.table_manager_maps[index]
        const svgRect = this.$refs.svgMap.getBoundingClientRect()

        // Calculăm offsetul pentru a prinde masa de mijloc
        this.offset.x = event.clientX - svgRect.left - (table.draw_data.x + table.draw_data.width / 2)
        this.offset.y = event.clientY - svgRect.top - (table.draw_data.y + table.draw_data.height / 2)
      },
      updateTablePosition (event) {
        if (this.selectedTableIndex !== null && !this.resizing) {
          const table = this.model.table_manager_maps[this.selectedTableIndex]
          const svgRect = this.$refs.svgMap.getBoundingClientRect()

          // Calculate new coordinates
          let newX = event.clientX - svgRect.left - this.offset.x - table.draw_data.width / 2
          let newY = event.clientY - svgRect.top - this.offset.y - table.draw_data.height / 2

          // Constrain within SVG bounds
          newX = Math.max(0, Math.min(newX, svgRect.width - table.draw_data.width))
          newY = Math.max(0, Math.min(newY, svgRect.height - table.draw_data.height))

          // Check for overlaps with other tables
          const isOverlapping = this.model.table_manager_maps.some((otherTable, index) => {
            if (index === this.selectedTableIndex) return false // Skip the selected table itself
            if (otherTable.deleted) return false // Skip the deleted table

            const otherDrawData = otherTable.draw_data
            return !(
              newX + table.draw_data.width <= otherDrawData.x || // Left of other table
              newX >= otherDrawData.x + otherDrawData.width ||   // Right of other table
              newY + table.draw_data.height <= otherDrawData.y || // Above other table
              newY >= otherDrawData.y + otherDrawData.height      // Below other table
            )
          })

          // Update position only if no overlap
          if (!isOverlapping) {
            table.draw_data.x = newX
            table.draw_data.y = newY
          }
        }
      },
      startResize (index) {
        this.selectedTableIndex = index
        this.resizing = true
      },
      resizeTable (event) {
        if (this.selectedTableIndex !== null && this.resizing) {
          const table = this.model.table_manager_maps[this.selectedTableIndex]
          const svgRect = this.$refs.svgMap.getBoundingClientRect()
          const mouseX = event.clientX - svgRect.left
          const mouseY = event.clientY - svgRect.top

          let newWidth = Math.max(20, mouseX - table.draw_data.x)
          let newHeight = Math.max(20, mouseY - table.draw_data.y)

          if (table.draw_data.x + newWidth > svgRect.width) {
            newWidth = svgRect.width - table.draw_data.x
          }
          if (table.draw_data.y + newHeight > svgRect.height) {
            newHeight = svgRect.height - table.draw_data.y
          }

          newWidth = Math.min(newWidth, 300)
          newHeight = Math.min(newHeight, 300)

          table.draw_data.width = newWidth
          table.draw_data.height = newHeight
        }
      },
      endResize () {
        this.resizing = false
      },
      rotateTable (index, angle) {
        const table = this.model.table_manager_maps[index]
        table.draw_data.rotation += angle
      },
      deleteTable (index, tableId) {
        if (this.model.table_manager_maps[index].table_manager_id !== -1) {
          this.model.table_manager_maps[index].deleted = true
          const tableToDelete = this.tables.find(t => t.id === tableId)
          if (tableToDelete) {
            tableToDelete.table_maps_id = 0
          }
        } else {
          if (this.model.id) {
            let tab = this.model.table_manager_maps[index]
            tab.deleted = true
            // this.model.table_manager_maps[index] = tab
            Vue.set(this.model.table_manager_maps, index, tab)
          } else {
            this.model.table_manager_maps.splice(index, 1)
          }
        }
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped lang="scss">
  .table-modal-back {
    display: inline-flex;
    width: auto;
  }
  .hide-loader .center {
    display: none;
  }
  .center {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .map {
    position: relative;
    width: 1000px;
    height: 600px;
    margin: auto;
  }
  .harta-bg {
    background-image: url(/static/img/bgTable3.jpg);
    background-color: rgba(240, 245, 255, 0.9);
    background-blend-mode: overlay;
    background-size: 50%;
    background-repeat: repeat;
    background-position: center;
    padding: 0px;
    position: relative;
    width: 100%;
  }

  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .allTables {
    padding: 10px;
    .table {
      position: relative;
      text-align: center;
      background-color: #ccc;
      border-radius: 5px;
      border: 1px solid #000;
      padding: 5px;
      cursor: grab;
      margin-bottom: 10px;
      .number {

      }
      .zone,
      .type {
        font-size: 12px;
        margin: 0;
      }
      .edit1 {
        color: #fff;
        margin: auto;
        cursor: pointer;
        font-size: 14px;
        background: #0097FC;
        border-radius: 100%;
        padding: 2px;
        position: absolute;
        right: 2px;
        top: 2px;
      }
    }
    .scrolDiv {
      max-height: 500px;
      overflow: auto;
      padding-right: 10px;
    }
    .newTable {
      width: auto;
      margin-right: 10px;
    }
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/maps/PosMapForm.vue